// r24 — /en/translate/naati/faq/$slug
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiFaqRenderer from "@/components/NaatiFaqRenderer";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";

export const Route = createFileRoute("/en/translate/naati/faq/$slug")({
  loader: async ({ params }) => {
    const { NAATI_FAQS } = await import("@/data/naati-faq-bank");
    const f = NAATI_FAQS.find((x) => x.slug === params.slug);
    if (!f) throw notFound();
    return { faq: f };
  },
  head: ({ loaderData }) => {
    const f = loaderData?.faq;
    if (!f) return { meta: [{ title: ctaTitle("Not found", "/en/translate/naati/faq/$slug", "en")}, { name: "robots", content: "noindex" }] };
    const url = `${SITE}/en/translate/naati/faq/${f.slug}`;
    const title = `${f.questionEn} | NAATI FAQ — NYC Language Institute`;
    return {
      meta: [
        { title: ctaTitle(title, "/en/translate/naati/faq/$slug", "en") }, { name: "description", content: ctaDesc(f.shortAnswerEn, "/en/translate/naati/faq/$slug", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/translate/naati/faq/$slug", "en")},
        { property: "og:description", content: ctaDesc(f.shortAnswerEn, "/en/translate/naati/faq/$slug", "en")},
        { property: "og:url", content: url }, { property: "og:locale", content: "en_US" },
      ],
      links: canonicalAndHreflang(`/translate/naati/faq/${f.slug}`, `/en/translate/naati/faq/${f.slug}`),
      scripts: [
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "en",
          mainEntity: [{ "@type": "Question", name: f.questionEn, acceptedAnswer: { "@type": "Answer", text: f.longAnswerEn } }],
        }) },
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "WebPage", "@id": `${url}#speakable`, url,
          speakable: { "@type": "SpeakableSpecification", cssSelector: ["[data-speakable]", ".direct-answer", "h1"] },
        }) },
      ],
    };
  },
  component: () => {
    const { faq } = Route.useLoaderData();
    return <NaatiFaqRenderer locale="en" faq={faq} />;
  },
});
